import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    projectLocationId: Yup.number().nullable(),
    surface: Yup.string().nullable(),
    analyzedBy: Yup.string().nullable(),
});

